/* Lucky Number 24 — (1) READABILITY GUARD (Mick's rule):
     - homepage: no text smaller than 16px anywhere
     - every other page: page content text at least 24px (header/footer stay 16px so
       navigation looks the same on every page)
     - EXCEPTION (Mick, 6 Oct 2026): the premium number-card widget [data-ln24-vanity] keeps its own
       compact sizes (min 14-16px set inside the widget) — the guard skips it.
   Any element rendering text below the minimum is bumped up.
   (2) "Available now" badge + glow/shine on every purchasable number card.
   (3) Loads page redesigns: ln24-policy.* on Shopify policy pages, ln24-choices.* on
       the "Your Privacy Choices" page. */
(function(){
  var SRC=(document.currentScript&&document.currentScript.src)||'';
  var MIN_HOME=16,MIN_PAGE=24;
  var API='https://numberbarn-search-api.vercel.app/api/available-numbers';
  var CARD_SEL='.ln24h-card,.ln24a-card,.ln24b-card,.ln24s-card,#ln24-fn .result-item';
  var FORM_TAGS={INPUT:1,SELECT:1,TEXTAREA:1,BUTTON:1,OPTION:1,LABEL:1};
  var SKIP_TAGS={SCRIPT:1,STYLE:1,NOSCRIPT:1,TEMPLATE:1,IFRAME:1,BR:1,IMG:1,VIDEO:1,CANVAS:1};
  function isHome(){var m=document.querySelector('main[data-template]');return !m||m.getAttribute('data-template')==='index';}
  function hasText(e){for(var c=e.firstChild;c;c=c.nextSibling){if(c.nodeType===3&&c.nodeValue.replace(/\s/g,'').length)return true;}return false;}
  function readable(){
    var home=isHome();var main=document.getElementById('MainContent');
    var els=document.body.getElementsByTagName('*');
    for(var i=0;i<els.length;i++){
      var e=els[i];
      if(SKIP_TAGS[e.tagName]||(window.SVGElement&&e instanceof SVGElement))continue;
      if(e.closest&&e.closest('[data-ln24-vanity]'))continue;
      if(!FORM_TAGS[e.tagName]&&!hasText(e))continue;
      var min=(!home&&main&&main.contains(e))?MIN_PAGE:MIN_HOME;
      var cs=window.getComputedStyle(e);var fs=parseFloat(cs.fontSize);
      if(fs&&fs<min-0.2){
        e.style.setProperty('font-size',min+'px','important');
        var lh=parseFloat(cs.lineHeight);if(lh&&lh<min*1.3){e.style.setProperty('line-height','1.4','important');}
      }
    }
  }
  function badge(text){var s=document.createElement('span');s.className='ln24-avail';s.appendChild(document.createElement('i'));s.appendChild(document.createTextNode(text||'Available now'));return s;}
  function fx(card){var g=document.createElement('span');g.className='ln24-glow';var sh=document.createElement('span');sh.className='ln24-shine';card.appendChild(g);card.appendChild(sh);}
  function mark(card){
    if(card.getAttribute('data-ln24live'))return;card.setAttribute('data-ln24live','1');
    card.classList.add('ln24-live-card');card.style.setProperty('--ln24-delay',(Math.random()*3.5).toFixed(2)+'s');
    if(card.matches('.ln24h-card,.ln24a-card')){var old=card.querySelector('.badge');if(old){old.parentNode.replaceChild(badge(),old);}else{card.insertBefore(badge(),card.firstChild);}}
    else if(card.matches('.ln24b-card')){var bw=card.querySelector('.ln24b-badges');if(bw){bw.insertBefore(badge(),bw.firstChild);}else{card.insertBefore(badge(),card.firstChild);}}
    else{card.insertBefore(badge(),card.firstChild);}
    fx(card);
  }
  function tick(t){if(t.getAttribute('data-ln24live'))return;t.setAttribute('data-ln24live','1');var d=document.createElement('i');d.className='ln24-dot-mini';t.insertBefore(d,t.firstChild);}
  function ago(ts){var s=Math.round((Date.now()-ts)/1000);if(s<10)return 'just now';if(s<60)return s+'s ago';return Math.round(s/60)+' min ago';}
  function detail(){
    var root=document.getElementById('ln24d-root');if(!root||root.getAttribute('data-ln24live'))return;
    var h=root.querySelector('h1');if(!h)return;var digits=(h.textContent||'').replace(/\D/g,'').slice(-10);if(digits.length!==10)return;
    root.setAttribute('data-ln24live','1');
    var b=badge('Checking availability…');b.classList.add('checking');var wrap=document.createElement('div');wrap.style.margin='0 0 8px';wrap.appendChild(b);h.parentNode.insertBefore(wrap,h);
    var label=b.lastChild;
    fetch(API+'?number='+digits).then(function(r){return r.json();}).then(function(j){
      b.classList.remove('checking');
      if(j&&j.numbers&&j.numbers.length){var ts=Date.now();label.nodeValue='Available now · verified '+ago(ts);setInterval(function(){label.nodeValue='Available now · verified '+ago(ts);},10000);}
      else{b.classList.add('gone');label.nodeValue='Just taken — no longer available';}
    }).catch(function(){b.classList.remove('checking');label.nodeValue='Available now';});
  }
  function loadAsset(name){
    if(document.getElementById('ln24-asset-'+name))return;
    var base=SRC.split('ln24-live.js')[0];if(!base)return;var v='?v='+Date.now();
    var l=document.createElement('link');l.rel='stylesheet';l.href=base+name+'.css'+v;document.head.appendChild(l);
    var s=document.createElement('script');s.id='ln24-asset-'+name;s.src=base+name+'.js'+v;document.body.appendChild(s);
  }
  function pageAssets(){
    if(document.querySelector('.shopify-policy__container'))loadAsset('ln24-policy');
    if(document.getElementById('pc--optOutFormContainer'))loadAsset('ln24-choices');
  }
  var queued=false;
  function scan(){queued=false;try{document.querySelectorAll(CARD_SEL).forEach(mark);document.querySelectorAll('.ln24a-tick').forEach(tick);detail();}catch(e){}try{readable();}catch(e){}}
  /* plain timer (not requestAnimationFrame): rAF can pause in background tabs, which left new cards unscanned */
  function queue(){if(queued)return;queued=true;setTimeout(scan,120);}
  function start(){document.documentElement.classList.add(isHome()?'ln24-home':'ln24-sub');try{pageAssets();}catch(e){}scan();new MutationObserver(queue).observe(document.body,{childList:true,subtree:true,characterData:true});window.addEventListener('resize',queue);setTimeout(scan,1200);setTimeout(scan,4000);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
